module.exports = __webpack_public_path__ + "img/bimata-p.ad87bf39.jpg";